/**
 * The top of How it works for an admin: Tutorial (the ten client chapters)
 * | Admin guide (the engine and its settings). Nobody else sees it.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { GraduationCap, ShieldCheck } from 'lucide-react';

import { SegmentedPills } from '@/components/ui';

type Part = 'tutorial' | 'admin';

const OPTIONS = [
  { value: 'tutorial', label: 'Tutorial', icon: GraduationCap },
  { value: 'admin', label: 'Admin guide', icon: ShieldCheck },
] as const;

export const PartSwitch: FC<{ admin: boolean; onChange: (admin: boolean) => void }> = ({ admin, onChange }) => (
  <div className="flex flex-wrap items-center gap-3">
    <SegmentedPills<Part> options={OPTIONS} value={admin ? 'admin' : 'tutorial'} onChange={(v) => onChange(v === 'admin')} />
    <span className="text-xs text-muted-foreground">The Admin guide is visible to admins only.</span>
  </div>
);
